module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (1).5584cda8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (1).jpg
// module id = 331
// module chunks = 0